import ApiError from '../../../../entities/api-error/ApiError'
import { OrderProduct } from '../../../../entities/order-product/OrderProduct'
import DashboardActionTypes from './DashboardActionTypes'

export interface RequestProductAccept {
  type: DashboardActionTypes.REQUEST_PRODUCT_ACCEPT;
  payload: {
    product: OrderProduct
    forceAccept?: boolean
    onEnd?: () => void
  }
}

export function requestProductAccept({
  product,
  forceAccept,
  onEnd,
}: RequestProductAccept['payload']): RequestProductAccept {
  return {
    type: DashboardActionTypes.REQUEST_PRODUCT_ACCEPT,
    payload: {
      product,
      forceAccept,
      onEnd,
    },
  }
}

export interface RequestProductAcceptSuccess {
  type: DashboardActionTypes.REQUEST_PRODUCT_ACCEPT_SUCCESS;
  payload: {
    product: OrderProduct
  }
}

export function requestProductAcceptSuccess({
  product,
}: RequestProductAcceptSuccess['payload']): RequestProductAcceptSuccess {

  return {
    type: DashboardActionTypes.REQUEST_PRODUCT_ACCEPT_SUCCESS,
    payload: {
      product,
    },
  }
}

export interface RequestProductAcceptFailure {
  type: DashboardActionTypes.REQUEST_PRODUCT_ACCEPT_FAILURE;
  payload: {
    product:  OrderProduct
    error:    ApiError;
  }
}

export function requestProductAcceptFailure({
  product,
 error,
}: RequestProductAcceptFailure['payload']): RequestProductAcceptFailure {

  return {
    type: DashboardActionTypes.REQUEST_PRODUCT_ACCEPT_FAILURE,
    payload: {
      product,
      error,
    },
  }
}
